// extracted by mini-css-extract-plugin
export default {"container":"fsZ7OF","post-page--split":"gZkZHV","postPageSplit":"gZkZHV"};